import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12bef306"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-center flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "md:w-96" }
const _hoisted_3 = { class: "mt-4 my-3 text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "signup-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-4 text-white text-xl" }, "Create Gamer Account", -1))
const _hoisted_7 = { class: "form-group mb-3" }
const _hoisted_8 = { class: "input-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-user text-red-primary opacity-95" })
  ])
], -1))
const _hoisted_10 = { class: "form-group mb-3" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "xr-icon-mail text-red-primary opacity-95",
      "aria-hidden": "true"
    })
  ])
], -1))
const _hoisted_13 = { class: "form-group mb-3" }
const _hoisted_14 = { class: "input-group has-validation" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-lock text-red-primary opacity-95" })
  ])
], -1))
const _hoisted_16 = ["type"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gray-text mt-2" }, "At least ONE capital letter, ONE number, and minumum 8 characters", -1))
const _hoisted_18 = { class: "form-group" }
const _hoisted_19 = ["disabled"]
const _hoisted_20 = {
  key: 1,
  class: "btn-primary-full"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-3 text-gray-text text-md" }, "Already have an account?", -1))
const _hoisted_22 = { class: "flex items-center" }
const _hoisted_23 = /*#__PURE__*/_createTextVNode("Click here to login ")
const _hoisted_24 = { class: "inline-block ml-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_authFooter = _resolveComponent("authFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/MetaXar-Games.svg'),
          class: "w-52 inline-block"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("form", null, [
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _hoisted_9,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                autocomplete: "off",
                class: "form-control",
                name: "userName",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.userName) = $event)),
                placeholder: "User Name (minimum 5 characters)"
              }, null, 512), [
                [_vModelText, _ctx.state.userName]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.userName.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "text-danger",
                key: error.$uid
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _hoisted_12,
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                name: "email",
                placeholder: "Email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.email) = $event))
              }, null, 512), [
                [_vModelText, _ctx.state.email]
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.email.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "text-danger",
                key: error.$uid
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", _hoisted_14, [
              _hoisted_15,
              _withDirectives(_createElementVNode("input", {
                type: _ctx.state.password.showConfirmPassword?'text':'password',
                autocomplete: "off",
                class: "form-control",
                name: "password",
                placeholder: "Password",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.password.password) = $event))
              }, null, 8, _hoisted_16), [
                [_vModelDynamic, _ctx.state.password.password]
              ]),
              _createElementVNode("span", {
                class: "btn btn-showPassword",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.password.showConfirmPassword = !_ctx.state.password.showConfirmPassword))
              }, [
                (_ctx.state.password.showConfirmPassword)
                  ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 0,
                      icon: "fa-solid fa-eye-slash",
                      class: "text-gray-text"
                    }))
                  : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                      key: 1,
                      icon: "fa-solid fa-eye",
                      class: "text-gray-text"
                    }))
              ])
            ]),
            _hoisted_17,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.v$.password.password.$errors, (error) => {
              return (_openBlock(), _createElementBlock("span", {
                class: "text-danger",
                key: error.$uid
              }, _toDisplayString(error.$message), 1))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_18, [
            (_ctx.activeSection == 'registerUser')
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "btn-primary-full",
                  onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.submitForm && _ctx.submitForm(...args))),
                  disabled: _ctx.disabled
                }, "Create Gamer Account", 8, _hoisted_19))
              : _createCommentVNode("", true),
            (_ctx.activeSection == 'loadingRegisterUser')
              ? (_openBlock(), _createElementBlock("button", _hoisted_20, "Creating..."))
              : _createCommentVNode("", true)
          ]),
          _hoisted_21,
          _createVNode(_component_router_link, {
            to: { name: 'viewAuthLogin' },
            class: "text-red-primary text-md inline-block"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_22, [
                _hoisted_23,
                _createElementVNode("i", _hoisted_24, [
                  _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-long-arrow-right" })
                ])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_authFooter)
        ])
      ])
    ])
  ]))
}